import { PhRadioButton } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

import type {
  Form,
  LocationSelectSection,
  LocationSelectSectionCreate,
  LocationSelectSectionUpdate,
} from '../../../types/FormBuilder.types'
import { formBlockMethods } from '../common/methods'

import LocationSelectEditor from './editor/LocationSelectEditor.vue'
import { createLocationSelectData } from './methods/createLocationSelectData'
import LocationSelectPreview from './preview/LocationSelectPreview.vue'

const i18n = i18nPlugin.global
const featureFlags = useFeatureFlags()

export const LocationSelectBlockModule: BuilderBlockModule<
  LocationSelectSection,
  LocationSelectSectionCreate,
  LocationSelectSectionUpdate,
  Form
> = {
  canAdd: () => featureFlags.isEnabled('hermes.locationSpecificForms'),
  createData: createLocationSelectData,
  editor: LocationSelectEditor,
  meta: [
    {
      icon: PhRadioButton,
      key: 'location-select',
      label: i18n.t('form-builder.blocks.location-select'),
      sort: 3,
    },
  ],
  methods: formBlockMethods,
  preview: LocationSelectPreview,
}
